import { safeAsyncStorage } from "../app/utils/safe-async-storage";
import { view } from "./storybook.requires";

import { LogBox } from "react-native";
LogBox.ignoreAllLogs(); //Ignore all log notifications

const StorybookUIRoot = view.getStorybookUI({
    storage: {
        getItem: safeAsyncStorage.getItem,
        setItem: safeAsyncStorage.setItem,
    },
});

export default StorybookUIRoot;
